import { gql } from "@apollo/client"
import { fetchLang, axiosLang } from '@util/http';
import { mockProductCardFields } from "@api/mock";

export const QUERY_USER = gql`
		query _QUERY_USER($params: UserParamDto!){
			users(params:$params)	{
				id
				name
				nickname
				signature
				registryTime
				phone
				email
				sex
				disabled
				avator
				client
				role
			}
		}
`

export const UPDATE_USER = gql`
	 mutation _UPDATE_USER($params:UserParamDto!){
		update_user(params:$params){
			success
			error	
		}
	}
	`

export const ADD_USER_ROLE = gql`
	 mutation _ADD_USER_ROLE($params:UserRoleDto!){
			add_user_role(role:$params) {
				success
			}
	 }
`

export const UPDATE_USER_ROLE = gql`
	 mutation _UPDATE_USER_ROLE($params:UserRoleDto!){
			update_user_role(role:$params) {
				success
			}
	 }
`


export function API_QUERY_USER(params) {
	return fetchLang("/api/user/queryUsers", {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}


export function API_UPDATE_USER(params) {
	return fetchLang("/api/user/updateUserInfo", {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 验证码验证 
export function verifyCode(params) {
	return fetchLang('/api/auth/verifyCode', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 获取用户微信信息 
export function wechatInfo(params) {
	return fetchLang('/api/wx/queryWechatInfo', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 发送邮箱验证码 
export function sendEmailCode(params) {
	return fetchLang('/api/auth/sendEmailCodeArtMuseum', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}


// 微信解绑 
export function wxUnbind(params) {
	return fetchLang('/api/wx/unbind', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 修改密码
export function updatePassword(params) {
	return fetchLang('/api/user/updatePassword', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 记录上次登录缓存信息
export function lastCache(params) {
	return fetchLang('/api/lastCache', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 获取当前用户信息
export function getCurrentUserInfo(params) {
	return fetchLang('/api/getCurrentUserInfo', {
		method: "GET",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 获取当前用户信息
export function queryUserByToken(token) {
	return fetchLang(`/api/queryUserByToken?token=${token}`, {
		method: "GET",
	}).then(res => res.json())
}

// 查询用户关注团队资材数据 根据资材名称 分页
export function queryInterestTeamProducts(params) {
	return fetchLang('/api/user/interest/queryInterestTeamProducts', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json()).then((res) => {
		// mock：卡片上的三级分类 / 上新推荐 / 附件类型等新增字段（开关关时原样返回，见 @api/mock）
		if (res?.result?.products) res.result.products = mockProductCardFields(res.result.products);
		return res;
	})
}

// 查询用户关注团队资材空间 搜索团队名称
export function queryList(params) {
	return fetchLang('/api/user/interest/queryList', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 取消关注
export function removeFocus(params) {
	return fetchLang('/api/user/interest/remove', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 置顶关注团队
export function updateTopTeam(params) {
	return fetchLang('/api/user/interest/updateTopTeam', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 关注团队
export function addFocus(params) {
	return fetchLang('/api/user/interest/save', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 查询用户关注团队信息
export function queryTeamInfo(params) {
	return fetchLang('/api/user/interest/queryTeamInfo', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 查询分类树
export function query_tree(params) {
	return fetchLang('/api/user/interest/query_tree', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 查询不觉用户信息
export function queryUserList(params) {
	return fetchLang('/api/admin/queryUserList', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 修改不觉用户团队限制数量
export function updateTeamLimit(params) {
	return fetchLang('/api/admin/updateTeamLimit', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 微信小程序用户自己上传到图片的数据
export function userDefinedCard(params) {
	return fetchLang('/api/team/userDefinedCard', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 微信小程序用户自己上传到图片的数据
export function upUserDefinedCard(params) {
	return fetchLang('/api/team/userDefinedCard', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 微信小程序 下载用户清单 得到项目
export function getUserLoginRecords(params) {
	return fetchLang('/api/loginHistory/getUserLoginRecords', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 获取用户 收藏列表的数据
export const collectableQueryFavoritesList = (params) => {

	const axios = axiosLang();
	const request = axios.post('/api/collectable/queryFavoritesList', params)
	// mock：收藏卡片上的三级分类 / 上新推荐 / 附件类型等新增字段（开关关时原样返回，见 @api/mock）
	return request.then((res) => {
		const groups = res?.data?.result;
		if (Array.isArray(groups)) {
			groups.forEach((group) => {
				if (Array.isArray(group?.productList)) {
					group.productList = mockProductCardFields(group.productList);
				}
			});
		}
		return res;
	})

}

// 收藏资材到数据库中
export const addOrCancelCollectableProduct = (params) => {
	return fetchLang('/api/collectable/addOrCancelCollectableProduct', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 已收藏的资材id
export const queryCollectableIds = (params={}) => {
	return fetchLang('/api/collectable/queryCollectableIds', {
		method: "POST",
		headers: {
			"content-type": "application/json"
		},
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 获取当前用户的空间计数
export const queryMySpaceList = () => {

	const axios = axiosLang();
	return axios.post('/api/collectable/queryMySpaceList', {})
}

/**
 * 用户有没有收藏这个项目
 * @param {*} params 
 */
export const userIsCollectPordetail = (params) => {
	const url = `/api/collectable/getProductCollectStatus`
	const axios = axiosLang();
	return axios.post(url, params)
}

/**
 *  入库项目
 * @param {*} params 
 * @returns 
 */
export const addCollectableCollectableStored = (params) => {
	const url = `/api/collectable/collectableStored`
	const axios = axiosLang();
	return axios.post(url, params)
}
